import React from 'react';
import styles from './ProfileWrapper.module.scss';
import { useNavigate } from 'react-router-dom';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
const ProfileWrapper = ({ children, title, edit, id }) => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate(`/edit-user/${id}`);
  };
  return (
    <div className={styles.cont}>
      <div className={styles.title}>
        <h3> {title}</h3>
        {edit && (
          <SvgWithBranding
            type="edit"
            onClick={handleNavigate}
            className={styles.icon}
          />
        )}
      </div>
      <div className={styles.horizantalLine}></div>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default ProfileWrapper;
